import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
// import { MsAdalAngular6Service } from 'microsoft-adal-angular6'; // Deprecated - using MSAL v3 instead
import { APIs } from '../config/api.constant';
import { AppConstant } from '../config/app.constant';
import { CoAdminModel } from '../model/CoAdmin.model';
import { TAModel } from '../model/TA.model';
import { AdminService } from '../services/admin.service';
import { ApiService } from '../services/api.service';
import { AppStateProvider } from '../services/app-state.provider';
import { CommonService } from '../services/common.service';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';


@Component({
  standalone: false,
  selector: 'app-profile-parkite',
  templateUrl: './profile-parkite.component.html',
  styleUrls: ['./profile-parkite.component.scss']
})
export class ProfileParkiteComponent implements OnInit {
  entryGate: any = [];
  meetingRoomAccess: any = [];
  deskAccess: any = [];
  privateSuiteAccess: any = [];
  accessPointChanged1 = [];
  accessPointChanged2 = [];
  useraccessPointChanged1 = [];
  useraccessPointChanged2 = [];
  name: boolean;
  email: boolean;
  mobile: boolean;
  dept;
  url: string;
  deptList: any;
  fullname1 = '';
  fullname2 = '';
  accessPointList: any;
  emailId1 = '';
  emailId2 = '';
  phoneNumber1 = '';
  phoneNumber2 = '';
  departmentName1: any;
  departmentName2: any;
  add1: boolean = true;
  add2: boolean = true;
  edit: boolean = false;
  closeResult: string;
  meetingNav: any;
  token: string;
  activeAdmin: number = null;
  taDetails = new TAModel;
  coAdmin1 = new CoAdminModel();
  coAdmin2 = new CoAdminModel();
  isCoAdmin1Exists: boolean = false;
  isCoAdmin2Exists: boolean = false;
  fieldErrors: any = [];
  initials: string = '';
  searchDept: string = '';
  initials1: string = '';
  initials2: string = '';
  moreDetails: any;
  updatedAccessPoints: any = []
  tempAccessPoints: any[];
  canChangeAccess: boolean = true;
  showPopOne: boolean = false;
  claCredits: any;
  isAdmin = localStorage.getItem('isRoleAdmin') == 'true' ? true : false;
  claId = localStorage.getItem(AppConstant.localStorage.claId);
  claAdminId = localStorage.getItem(AppConstant.localStorage.claAdminId);
  activeToggle = "toggle-1";
  disableAdd = false;
  showCoAdmin: boolean = true;
  userType = localStorage.getItem('userType');
  parkiteCoadminList: any[] = []
  coAdminList: any;
  isEdit: boolean;
  departmentName: any;
  editedData: any;
  constructor(
    private commonService: CommonService, 
    private appStateSrv: AppStateProvider, 
    private apiService: ApiService, 
    private adminSrv: AdminService, 
    private router: Router, 
    // private adalService: MsAdalAngular6Service,
    private authService: MsalService,
    ) {
  }

  ngOnInit(): void {
    console.log(this.isAdmin)

    this.meetingNav = [
      {
        index: "10",
        name: "Profile",
        link: '/profile-parkite'
      }
    ];

    const route = {
      index: "10",
      name: "Profile",
      link: '/profile-parkite'
    };
    this.appStateSrv.setSideNavState(route);

    this.getParkiteProfileDetail()
    this.getParkiteDepartmentDetails();

    // localStorage.removeItem('expandNavLand');

  }


  getParkiteDepartmentDetails() {
    this.url = APIs.getParkiteDepartmentList;

    this.apiService.get(this.url, '').subscribe(
      (response: any) => {
        this.deptList = response.list;
        console.log('deptList', this.deptList.list);
        this.getAllCoAdmins();
      },
      err => console.log('error', err)
    );

  }

  ngAfterViewInit() {
    this.accodionClick('toggle-1-header', true)
  }


  getParkiteProfileDetail() {
    const data = {
      isCla: true
    }
    this.commonService.getProfileDetail(data).subscribe(res => {

      this.taDetails.name = res?.adminName,
        this.taDetails.mobileNumber = res?.mobileNumber,
        this.taDetails.emailId = res?.adminEmail,
        this.taDetails.department = res?.departmentName,
        this.initials = this.generateInitials(res?.adminName)

    })
  }


  getAllCoAdmins() {
    this.parkiteCoadminList = []
    this.adminSrv.getParkiteCoAdmins().subscribe(res => {

      console.log("coadmin", res.length)
      if (res?.length > 0) {
        res?.forEach(element => {
          const data = {
            fullname: element?.adminName,
            emailId: element?.adminEmailId,
            phoneNumber: element?.phoneNumber,
            id: element?.id,
            departmentId: element?.departmentId,
            // profileUrl : element.profileUrl ? element.profileUrl : '',
            initials: this.generateInitials(element.adminName),
            isCoAdmin1Exists: true,
          }
          this.parkiteCoadminList.push(data)
        });
      }
      else {
        this.parkiteCoadminList.push({})
      }
      console.log("listt", this.parkiteCoadminList)
    })

  }

  getDepartmentName(id) {
    this.departmentName = this.deptList.find(ele => ele.id == id).department
    return this.deptList.find(ele => ele.id == id).department
  }

  setDepartmentName(id, i) {
    this.parkiteCoadminList[i].departmentId = id;
    this.getDepartmentName(id)
  }


  addCoAdmin(id) {
    this.editedData = this.parkiteCoadminList.find(ele => ele.id == id)
    this.disableAdd = true;
    const requestData =
    {
      adminName: this.editedData.fullname,
      adminEmailId: this.editedData.emailId.toLowerCase(),
      isActive: true,
      parentId: JSON.parse(localStorage.getItem(AppConstant.localStorage.userId)),
      phoneNumber: this.editedData.phoneNumber,
      departmentId: this.editedData.departmentId,
      createdDate: new Date().toISOString(),
      // image: '',
      // profileUrl: '',
      id: (id !== null) && (id !== undefined) ? id : 0,
      isAdmin: false,
      parkId: localStorage.getItem('parkId'),
    }
    console.log("request data", requestData)
    this.adminSrv.addParkiteEmployee(requestData).subscribe(
      (response: any) => {
        this.disableAdd = false;
        if (response.isValid) {
          this.isEdit = false
          this.getAllCoAdmins();
        }

      }
    );
  }

  cancelAdmin(coadmin) {
    window.location.reload();
  }

  enterName(field, adminNumber) {
    if (field == 'name1') {
      this.name = !this.name;
      if (this.fullname1.length != 0) {
        this.name = true;
      }
    }
    if (field == 'email1') {
      this.email = !this.email;
      if (this.emailId1.length != 0) {
        this.email = true;
      }
    }
    if (field == 'mobile1') {
      this.mobile = !this.mobile;
      if (this.phoneNumber1.length != 0) {
        this.mobile = true;
      }
    }
    else if (field = 'department') {
      this.dept = !this.dept;
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }
  openPopover(popover) {
    this.searchDept = '';
    if (popover.isOpen()) {
      popover.close();

    } else {
      popover.open();

    }
  }

  formValidator(adminNumber: number, type: string = "add"): { valid: boolean, errFields: any } {
    // console.log("came here with ", adminNumber);

    const validate = (name, email, phone, dept) => {

      let errFields = [];
      if (type == 'name' || type == "add")
        if (!name || !/^[a-zA-Z ]{2,50}$/.test(name)) {
          if (name.length > 50) {
            const i = errFields.indexOf('name');
            if (i > -1)
              errFields.splice(i, 1);
            errFields.push('name');
          } else {
            const i = errFields.indexOf('name');
            if (i > -1)
              errFields.splice(i, 1);
          }
          const i = errFields.indexOf('name');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('name');
        } else {
          const i = errFields.indexOf('name');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (type == 'email' || type == "add")
        if (!email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)) {
          const i = errFields.indexOf('email');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('email');
        } else {
          const i = errFields.indexOf('email');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (type == 'phone' || type == "add")
        if (!phone || !/^\d{10}$/.test(phone)) {
          const i = errFields.indexOf('phone');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('phone');
        } else {
          const i = errFields.indexOf('phone');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (type == 'dept' || type == "add")
        if (!dept || dept == undefined || dept == '') {
          const i = errFields.indexOf('dept');
          if (i > -1)
            errFields.splice(i, 1);
          errFields.push('dept');
        } else {
          const i = errFields.indexOf('dept');
          if (i > -1)
            errFields.splice(i, 1);
        }
      if (errFields.length > 0)
        return { valid: false, errFields: errFields };
      else
        return { valid: true, errFields: [] };
    }
    console.log(this.parkiteCoadminList)

    let valData = this.parkiteCoadminList.find(ele => ele.id == adminNumber)

    return validate(valData.fullname, valData.emailId, valData.phoneNumber, valData.departmentId)

  }

  inputModelChange(adminNumber: number, type: string) {
    if (type == 'email') {
      this.textToLowercase(adminNumber);
    }
    const formStatus = this.formValidator(adminNumber, type);
    this.fieldErrors = [];
    if (!formStatus.valid)
      this.fieldErrors = formStatus.errFields;
    // console.log('fields errors', this.fieldErrors);

  }

  addClick(type: string, coAdminNumber: number) {
    console.log('addclick', type, coAdminNumber);

    switch (type) {
      case 'add':
        const formStatus = this.formValidator(coAdminNumber);
        if (!formStatus.valid) {
          console.log("error")
          this.fieldErrors = formStatus.errFields;
          return;
        }
        console.log("no error")
        this.fieldErrors = [];
        this.addCoAdmin(coAdminNumber);
        break;
      case 'edit':
        this.isEdit = true;
        this.name = true;
        this.email = true;
        this.mobile = true;
        this.dept = true;

        break;
      default:
        break;
    }

    // console.log('status', this.add1, this.add2);
  }

  drawerClick(adminNumber: number, status?) {

    this.activeAdmin = adminNumber;
    this.name = false;
    this.email = false;
    this.mobile = false;
    this.dept = false;

  }

  generateInitials(fullName: string): string {

    if (fullName !== '' && fullName !== null && fullName !== undefined)
      return (fullName.split(' ')[0].charAt(0).toUpperCase()) + ' ' + ((fullName.split(' ')[1] === undefined || fullName.split(' ')[1] === null) ? '' : fullName.split(' ')[1].charAt(0).toUpperCase());
    else
      return '';
  }

  removeCoAdmin(id) {

    this.adminSrv.removeParkiteCoAdmin(id).subscribe(response => {
      setTimeout(() => {
        window.location.reload();
      }, 1000)
    })
  }

  logout() {

    this.commonService.logoutToken().subscribe((res) => {
      if (res) {
        localStorage.clear();

        // this.adalService.logout();
        // this.authService.logoutRedirect();
        this.logoutFromAd();

        setTimeout(() => {
          this.router.navigateByUrl("").then(() => {
            window.location.reload();
          });
        }, 1000)
      }
    })
  }

  logoutFromAd(popup?: boolean) {
    // if (popup) {
    //   this.authService.logoutPopup({
    //     mainWindowRedirectUri: environment.domain + '/' // "http://localhost:4200/"
    //   });
    // } else {
    //   this.authService.logout();
    // }
    window.location.href=`https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${encodeURI(environment.domain)}`
  }

  accodionClick(id: string, status: boolean) {

    this.isEdit = false
    for (let i = 1; i < this.parkiteCoadminList.length; i++) {
      document.getElementById('toggle-' + i + '-header').classList.remove('open-state');
    }
  }

  textToLowercase(type) {
    if (type == undefined) {
      this.parkiteCoadminList[this.parkiteCoadminList.length - 1].emailId = this.parkiteCoadminList[this.parkiteCoadminList.length - 1].emailId.toLowerCase();
    } else {
      this.parkiteCoadminList[type].emailId = this.parkiteCoadminList[type].emailId.toLowerCase();
    }
  }

  addNewCoadmin() {

    this.parkiteCoadminList.push({ departmentId: 0, emailId: '' })
  }

}
